import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent'
import { useEffect } from 'react'
import * as ReactGA from 'react-ga'
import { useTranslation } from 'react-i18next'
import { CoockieIcon } from '../../../icons/CoockieIcon'

const CookieConsentComponent = () => {
  const { t } = useTranslation('translation')
  const handleAcceptCookie = () => {
    initGA('G-TVR2VW7RJN')
  }

  const initGA = (id) => {
    ReactGA.initialize(id)
  }

  useEffect(() => {
    const isConsent = getCookieConsentValue()
    if (isConsent === 'true') {
      handleAcceptCookie()
    }
  }, [])

  return (
    <div className="cookie-consent-modal">
      <CookieConsent
        enableDeclineButton
        overlay
        onAccept={handleAcceptCookie}
        onDecline={handleAcceptCookie}
        style={{
          background: '#CFF2DF',
        }}
        buttonText={t('accept_all_cookies')}
        declineButtonText={t('accept_only_the_necessary_ones')}
        buttonStyle={{
          background: '#00cf83',
          borderRadius: '8px',
          color: '#004949',
        }}
        declineButtonStyle={{
          background: '#CFF2DF',
          borderRadius: '8px',
          color: '#004949',
          border: '1px solid #004949',
        }}
      >
        <div
          style={{
            height: 'max-content',
          }}
        >
          <CoockieIcon />
          <span className="text-on-bg-primary" style={{ marginLeft: '12px' }}>
            {t(
              'we_use_cookies_to_improve_your_experience_by_continuing_to_browse_you_agree_to_their_use'
            )}{' '}
          </span>
        </div>
      </CookieConsent>
    </div>
  )
}

export default CookieConsentComponent
